import { handleResponse } from "utils/utils";
import { authService } from "services";

export const expenseTypesService = {
    getAll,
    getById,
    add,
    update,
    remove,
};

// get expense types
function getAll(options) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    let query = '?sort=+name';

    if (options) {
        let { q } = options;

        if (q !== undefined)
            query += "&q=" + q;
    }

    return fetch(`${global.BASE_API}expense-types${query}`, requestOptions).then(handleResponse);
}

// get expense types by id
function getById(id) {
    const requestOptions = {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}expense-types/${id}`, requestOptions).then(handleResponse);
}

// add new expense type
function add(expense) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(expense)
    };

    return fetch(`${global.BASE_API}expense-types/`, requestOptions).then(handleResponse);
}

// update expense type
function update(expense) {
    const requestOptions = {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(expense)
    };

    return fetch(`${global.BASE_API}expense-types/${expense.id}`, requestOptions).then(handleResponse);
}

// remove expense type
function remove(id) {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${authService.token.access_token}`
        },
    };

    return fetch(`${global.BASE_API}expense-types/${id}`, requestOptions).then(handleResponse);
}
